<template>
  <SidebarPanel>
    <template v-slot:icon>
      <router-link to="/">
        <Logo light="assets/i/logo_group.png" dark="assets/i/logo_group.png" />
      </router-link>
    </template>
    <Item icon="i-menu">
      <Navigation>
        <NavigationLink :to="{ name: 'main' }" icon="i-app">{{ $t("menu.main") }}</NavigationLink>
      </Navigation>
    </Item>
    <Item bottom icon="i-info">
      <section>
        <p>Text</p>
      </section>
    </Item>
  </SidebarPanel>
</template>

<script>
import {
  SidebarPanel,
  Logo,
  Item,
  Navigation,
  NavigationLink
} from "./sidebar";

export default {
  components: {
    SidebarPanel,
    Logo,
    Item,
    Navigation,
    NavigationLink
  }
};
</script>
